/**
 * FilterSection Component
 * Standard filters/search area with consistent margin bottom
 * Text fields within filter sections should not have margin bottom
 */

import React from 'react';
import { Box } from '@mui/material';
import { PAGE_BODY } from '../../theme';

const FilterSection = ({ children, sx = {} }) => {
  return (
    <Box
      sx={{
        mb: `${PAGE_BODY.margins.filterBottom}px`,
        // Remove margin-bottom from text fields within filter sections
        '& .MuiTextField-root': {
          marginBottom: 0,
        },
        '& .MuiFormControl-root': {
          marginBottom: 0,
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default FilterSection;
